export const TrashIconV2 = (props) => (
  <svg fill="none" height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.6654 6.11115L18.1145 15.0223C17.9737 17.2991 17.9034 18.4375 17.3327 19.2559C17.0505 19.6606 16.6873 20.0021 16.266 20.2587C15.4139 20.7778 14.2734 20.7778 11.9922 20.7778C9.70814 20.7778 8.56608 20.7778 7.71341 20.2577C7.29185 20.0007 6.92848 19.6585 6.64641 19.2532C6.07592 18.4335 6.0071 17.2935 5.86946 15.0135L5.33203 6.11115"
      stroke={props.color ? props.color : "#667085"}
      strokeLinecap="round"
      strokeWidth={1.33333}
    />
    <path
      d="M4 6.11111H20M15.6051 6.11111L14.9983 4.85932C14.5952 4.02779 14.3936 3.61202 14.046 3.35272C13.9689 3.2952 13.8872 3.24404 13.8018 3.19973C13.4168 3 12.9548 3 12.0307 3C11.0834 3 10.6098 3 10.2184 3.20811C10.1316 3.25423 10.0489 3.30747 9.97092 3.36726C9.61924 3.63707 9.42278 4.06804 9.02988 4.93001L8.49148 6.11111"
      stroke={props.color ? props.color : "#667085"}
      strokeLinecap="round"
      strokeWidth={1.33333}
    />
  </svg>
);
